<script>
import Layout from '@layouts/default'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import Swal from 'sweetalert2'
import axios from 'axios'

/**
 * Login component
 */
export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      password: '',
      showPassword: true,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      loadingImage: true,
      fileUrl: '',

      isRecovery: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      isSuccess: false,
      successMessage: null,
      resetSent: false,
      loadReset: false,
    }
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            email: 'Use "admin" to log in with the mock API',
            password: 'Use "password" to log in with the mock API',
          }
    },
  },
  created() {
    this.loadLoginImagem()
  },
  methods: {
    ...authMethods,
    async tryToLogIn() {
      this.tryingToLogIn = true
      this.authError = null
      this.isAuthError = false

      let respUserValidated = await this.validateUserIsLogged({email: this.email, password: this.password})
      //console.log("respUserValidated: ", respUserValidated.haveUserLogged);
      if(respUserValidated && respUserValidated.validate === true) {
        if(respUserValidated.haveUserLogged){

          Swal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text: 'Possui um usuário logado nessa conta. Você deseja encerrar todas as outras sessões e acessar o sistema?',
            showDenyButton: true,
            // showCancelButton: true,
            confirmButtonText: 'Encerrar',
            confirmButtonColor: '#dc3741',
            denyButtonText: `Não encerrar`,
            denyButtonColor: '#5bb7c9',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {

              this.logoutUser(respUserValidated.userId)

              const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
              })

              Toast.fire({
                icon: 'success',
                title: 'Usuário logado com sucesso!'
              })

              return this.logIn({
                email: this.email,
                password: this.password,
              })
              .then((token) => {
                this.tryingToLogIn = false
                this.isAuthError = false

                this.$router.push(
                  this.$route.query.redirectFrom || { name: 'Dashboard' }
                )
              })
              .catch((error) => {
                this.alterBlockButton()
                this.tryingToLogIn = false
                this.authError = 'Acesso não autorizado.'
                this.isAuthError = true
              })

            } else if (result.isDenied) {
              //Swal.fire('Changes are not saved', '', 'info')
            }
          })

        } else {
          return this.logIn({
            email: this.email,
            password: this.password,
          })
          .then((token) => {
            this.tryingToLogIn = false
            this.isAuthError = false

            this.$router.push(
              this.$route.query.redirectFrom || { name: 'Dashboard' }
            )
          })
          .catch((error) => {
            this.alterBlockButton()
            this.tryingToLogIn = false
            if(respUserValidated.code === 99500) {
              this.authError = '(99500) Erro em conectar! Atualize o navegador, se percistir entr em contato com o suporte.'
              this.isAuthError = true
            } else {
              this.authError = 'Acesso não autorizado.'
              this.isAuthError = true
            }

          })
        }

      } else {
        //this.alterBlockButton()
        this.tryingToLogIn = false
        this.authError =`Acesso não autorizado. (${respUserValidated.code})`
        this.isAuthError = true
        return;
      }

      /*return this.logIn({
        email: this.email,
        password: this.password,
      })
        .then((token) => {
          this.tryingToLogIn = false
          this.isAuthError = false

          this.$router.push(
            this.$route.query.redirectFrom || { name: 'Dashboard' }
          )
        })
        .catch((error) => {
          this.alterBlockButton()
          this.tryingToLogIn = false
          this.authError = 'Acesso não autorizado.'
          this.isAuthError = true
        })*/
    },
    logoutUser(userId){
      axios
      .post(`${process.env.VUE_APP_ROOT_API}/logout/`,
      {
        "token": '',
        "userId": userId
      })
      .then((response) => {
        //this.$router.push({name: "logout"})
        return response.data
      })
      .catch(err => {
        console.log(err);
        console.log(err.data);
      })
    },
    loadLoginImagem(){
      const url = `${process.env.VUE_APP_ROOT_API}/modules/login-img/`;
      axios.get(url,{
        responseType: 'blob',  // Configurar a resposta como um objeto Blob
      })
      .then(response => {
        let fileType = response.data.type
        var regex = /(png|jpe?g)$/i;

        // Validar se o arquivo é uma imagem
        if (regex.test(fileType)) {
          fileType = `image/${fileType.replace('application/', '')}`
          this.isImage = true;
        }

        const url = window.URL.createObjectURL(new Blob([response.data], { type: fileType }));
        // const link = document.createElement('a');

        this.fileUrl = url
        this.modalState = true
        // this.fileSelectedToBlob = file
        // console.log("fileUrl: ", this.fileUrl);

        this.loadingImage = false

        //link.setAttribute('download', fileName);

        //window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error(error);
        this.loadingImage = false
      });
    },
    setLoginRecovery(){
      this.isRecovery = !this.isRecovery
    },
    tryToReset() {
      this.tryingToReset = true
      // Reset the authError if it existed.
      this.error = "Erro em recuperar tente novamente mais tarde"//null
      return this.resetPassword({
        email: this.email,
      })
      .then((data) => {
        if (data.status >= 400){
          this.tryingToReset = false
          this.error = data.erro.email ? "Erro em recuperar: " + data.erro.email[0] :  this.error
          this.isResetError = true
          this.isSuccess = false

        }else{
          this.tryingToReset = false
          this.isResetError = false
          this.isSuccess = true
          this.successMessage = data.message !== "" ? "Um e-mail foi enviado com os passos para recuperar a senha. Caso não tenha recebido o e-mail com as informações, verifique se o e-mail está correto e tente novamente." : data.message
          this.resetSent = true;
          this.loadReset = true;
          setTimeout(() => {
            this.email = ""; //limpa o campo email
            
            this.resetSent = false;
            this.loadReset = false;
          }, "3000")

        }

      })
      .catch((error) => {
        if( error.response){
          this.tryingToReset = false
          this.error = error ? "Erro em recuperar: " + error.response.data[0] : ''
          this.isResetError = true
          this.isSuccess = false
        } else {
          this.tryingToReset = false
          this.error = "Erro em recuperar: Erro interno no servidor"
          this.isResetError = true
          this.isSuccess = false
        }
      })

    },

  },
}
</script>

<template>
  <Layout>
    <div class="card login-card shadow">
      <div class="row w-100 h-100">
        
        <div class="col-md-6 px-0 d-flex align-items-center justify-content-center">
          <div class="wraper-login">
            <div class="card-login-area">
              <!-- Logo -->
              <div class="text-center logo-section">
                <router-link to="/">
                  <span v-if="this.$route.params.empresa === 'cfi' || this.$route.path.split('/').includes('cfi')" class="d-flex justify-content-between align-items-center">
                    <img src="@assets/images/cfi_images/Ativo 10.png" alt height="60" />
                    <img src="@assets/images/cfi_images/logo-ministerio-economia-realizacao.png" alt height="45" />
                  </span>
                  <span v-else >
                    <img class="lg-logo" src="@assets/images/logo-liciteGov.png" alt height="79" />
                  </span>
                </router-link>
              </div>
              <div class="card-body">
                <div v-if="!isRecovery">
                  <b-alert
                    v-model="isAuthError"
                    variant="danger text-center"
                    dismissible
                    >{{ authError }}
                  </b-alert>
                  <b-form @submit.prevent="tryToLogIn">
                    <div class="form-group">
                      <label for="input-1">
                        <img class="icon-label" src="../../../assets/images/mail.png" alt="Email icon">
                        E-mail
                      </label>
                      <input id="input-1" v-model="email" 
                        type="email" class="form-control" 
                        placeholder="Digite seu E-mail"
                        required
                      >
                    </div>
                    <div class="form-group" style="position: relative;">
                      <label for="input-2">
                        <img class="icon-label" src="../../../assets/images/Lock.png" alt="Senha icon">
                        Senha
                      </label>
                      <input id="input-2" v-model="password"
                        :type="`${showPassword ? 'password' : 'text'}`" 
                        class="form-control" 
                        placeholder="Digite sua senha"
                        required
                      >
                      <div class="eye-password" @click="showPassword = !showPassword ">
                        <i v-if="showPassword" class="uil uil-eye text-primary"></i>
                        <i v-else class="uil uil-eye-slash text-primary"></i>
                      </div>
                    </div>

                    <!-- <b-form-checkbox
                      id="checkbox-1"
                      class="mb-3"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                      >Lembrar de mim</b-form-checkbox
                    > -->

                    <div class="form-group mb-0 text-center mt-4">
                      <b-button
                        v-if="!this.$store.state.auth.blockBtnLogin"
                        type="submit"
                        variant="primary"
                        >Entrar</b-button
                      >
                      <b-button v-else variant="primary" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        Aguarde...
                      </b-button>
                    </div>
                    
                  </b-form>
                </div>

                <div v-else>
                  <b-alert v-model="isResetError" variant="danger" dismissible>{{error}}</b-alert>

                  <b-alert v-model="isSuccess" variant="success" dismissible>{{successMessage}}</b-alert>
                  
                  <div v-if="tryingToReset" class="d-flex justify-content-center my-5">
                    <div class="spinner-grow text-primary" role="status"></div>
                  </div>
                  <b-form v-if="!tryingToReset && !resetSent" class="form-mail" @submit.prevent="tryToReset">
                    <div class="form-group">
                      <label for="input-mail">
                        <img class="icon-label" src="../../../assets/images/mail.png" alt="Email icon">
                        E-mail
                      </label>
                      <input id="input-mail" v-model="email" 
                        type="email" class="form-control" 
                        placeholder="Digite seu E-mail"
                        required
                      >
                    </div>
                    
                    
      
                    <div class="form-group mb-0 text-center">
                      <b-button type="submit" variant="primary">Redefinir senha</b-button>
                    </div>
                  </b-form>
                </div>
                <div class="d-flex justify-content-center mt-4">
                  <!-- <router-link
                    :to="{ name: 'forget-password' }"
                    class="forgot-pass"
                  >
                    Esqueceu a sua senha?
                  </router-link> -->
                  
                  <p v-if="!isRecovery" class="forgot-pass" @click="setLoginRecovery">
                    Esqueceu a sua senha?
                  </p>
                  <p v-else class="forgot-pass" @click="setLoginRecovery">
                    Voltar para o login
                  </p>
                </div>
              </div>
            </div>
              
            <div class="text-muted text-center" style="margin-top: 50px; font-size: 16px;">
              {{ new Date().getFullYear() }} © LiciteGov - <a class="text-muted" href="https://licitegov.com.br/">www.licitegov.com.br</a>
            </div>
          </div>
        </div>

        <div class="col-md-6 d-none d-md-flex justify-content-center align-items-center px-0 img-contain">
          <div v-if="loadingImage" class="d-flex justify-content-center align-items-center" >
            <img class="pulsate-bck" src="@assets/images/logo-liciteGov.png" alt="Licitegov" height="65" />

          </div>
          <div v-else >
            <img v-if="fileUrl !== ''" class="side-login-img img-fluid" :src="fileUrl" alt="bg-login">
            <img v-else class="side-login-img img-fluid" src="/Atencao_Licitantes.jpg" alt="bg-login">
            <!-- <h4 class="text-dark-50">Bem-vindo de volta!</h4>
            <p class="text-muted mb-4">Faça login para continuar.</p> -->
          </div>
        </div>
        
      </div>
      <!-- end card-body -->
    </div>
    <!-- end card -->
    
  </Layout>
</template>

<style lang="scss" scoped>
.login-card{
  align-items: center;
  margin: 0;
  height: 100%;

  .side-login-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-width: 650px;
    display: block;
    margin-left: auto;
  }
  .eye-password {
    position: absolute;
    right: 10px;
    margin-top: -32px;
    font-size: 1.2rem;
    padding: 0px 5px;
    opacity: 0.7;
  }
}
.wraper-login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 440px;
  width: 100%;
}
@media (max-width: 768px) {
  .wraper-login {
    padding-right: 15px;
    padding-left: 15px;

    .logo-section {
      padding-top: 35px;
      padding-bottom: 35px;
      margin-bottom: 60px;
    }
    .card-body {
      padding-bottom: 50px;
    }
  }
  
}
.card-login-area {
  
  border-radius: 30px;
  box-shadow: 0 0 20px 0 #00000040;
}
.icon-label {
  width: 20px;
  margin-right: 5px;  
}
.logo-section {
  background-color: #e5e5e5;
  border-radius: 30px;
  padding-top: 55px;
  padding-bottom: 55px;
  margin-bottom: 80px;

  .lg-logo {
    width: 154px;
  }
}
.login-card {
  .card-body {
    padding-bottom: 100px;
    padding-top: 0;
  }
}
.forgot-pass{
  color: #3B8593;
  text-decoration: underline;
  cursor: pointer;
}
.img-contain {
  border-right: 1px solid #e5e5e5;
  // height: 100%;
  position: relative;
}
.img-contain>div{
  height: 100%;
  width: 100%;
}
.pulsate-bck {
  opacity: 0.5;
	-webkit-animation: pulsate-bck 0.5s ease-in-out infinite both;
  animation: pulsate-bck 0.5s ease-in-out infinite both;
}
@-webkit-keyframes pulsate-bck {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
@keyframes pulsate-bck {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
</style>
